import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import './Header.css';
import logo from '../assets/logo.png'; // Assuming the logo is saved as logo.png in assets folder

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className={scrolled ? 'header scrolled' : 'header'}>
      <div className="container header-container">
        <div className="logo">
          <img src={logo} alt="Exam Guide Home Tuitions" className="logo-image" />
        </div>
        
        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={mobileMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <button className="close-menu-btn" onClick={toggleMobileMenu}>
            <i className="fas fa-times"></i>
          </button>
          <ul>
            <li><HashLink smooth to="#home" onClick={() => setMobileMenuOpen(false)}>Home</HashLink></li>
            <li><HashLink smooth to="#why-choose-us" onClick={() => setMobileMenuOpen(false)}>Why choose us</HashLink></li>
            <li><HashLink smooth to="#find-tutors" onClick={() => setMobileMenuOpen(false)}>Find tutors</HashLink></li>
            <li><HashLink smooth to="#register-tutor" onClick={() => setMobileMenuOpen(false)}>Join as Tutor</HashLink></li>
            <li><HashLink smooth to="#contact" onClick={() => setMobileMenuOpen(false)}>Contact</HashLink></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 